// Styles
import { makeStyles, tokens } from "@fluentui/react-components";
/**
 * Get styles for DynamicIcon using Fluent UI v9 makeStyles
 */ export const useDynamicIconStyles = makeStyles({
    focused: {
        transition: `transform ${tokens.durationFast} ${tokens.curveEasyEase}, box-shadow ${tokens.durationFast} ${tokens.curveEasyEase}`
    }
});
